import { render, staticRenderFns } from "./blogPage.vue?vue&type=template&id=30a88204&scoped=true"
import script from "./blogPage.vue?vue&type=script&lang=ts"
export * from "./blogPage.vue?vue&type=script&lang=ts"
import style0 from "./blogPage.vue?vue&type=style&index=0&id=30a88204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a88204",
  null
  
)

export default component.exports